export default __webpack_public_path__ + "static/media/GoodMannerInPublic_01.43cbb4ca.png";